import { render, staticRenderFns } from "./remaining-sum.vue?vue&type=template&id=224ac5ea&scoped=true"
import script from "./remaining-sum.vue?vue&type=script&lang=js"
export * from "./remaining-sum.vue?vue&type=script&lang=js"
import style0 from "./remaining-sum.vue?vue&type=style&index=0&id=224ac5ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ac5ea",
  null
  
)

export default component.exports